import { GET_GROUPS, GET_GROUPS_SUCCESS, API_ERROR } from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  groups: undefined,
}

const GroupsList = (state = initialState, action) => {
  switch (action.type) {
    case GET_GROUPS:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_GROUPS_SUCCESS:
      {
        const payloadGroups = action.payload.groups
        const normalizedGroups = Array.isArray(payloadGroups)
          ? payloadGroups
          : payloadGroups?.data && Array.isArray(payloadGroups.data)
          ? payloadGroups.data
          : []
        state = {
          ...state,
          groups: normalizedGroups,
          loading: false,
          done: true,
        }
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default GroupsList
